import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { AlertService, AuthenticationService } from '../../_services';
import { MsalService } from '@azure/msal-angular';
import { Security } from 'src/app/_helpers/security.util';
import { AuthenticationResult } from '@azure/msal-browser';
import { Subject } from 'rxjs';


@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['login-page.component.css']
})
export class LoginPageComponent implements OnInit {
    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    hide = true;
    private readonly _destroying$ = new Subject<void>();

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private authService: MsalService) { }


    ngOnInit() {
      this.authService.handleRedirectObservable().subscribe({
        next: (result: AuthenticationResult) => {
          if (!result){
            this.logaNoAD();
          } else if (!Security.validouPAG()){
                let tokenAuthorize = '';
                this.authenticationService.getProfile().subscribe(
                  data => {
                    tokenAuthorize = btoa(JSON.stringify(data));
                    this.logaNoPag(tokenAuthorize);
                  },
                  err => {
                    console.log(err);
                  }
                )
             } else {
                this.router.navigateByUrl("/home");
             }
        },
        error: (error) => console.log(error)
      });
    }

    logaNoAD(): void {
        try {
          this.authService
          .acquireTokenRedirect({scopes: ["openid", "profile", "user.read"]})
          .subscribe();
        } catch (error) {
          console.log(error);
        }
    }


    logaNoPag(tokenAuthorize): void{
        this.authenticationService.login(
            tokenAuthorize
        ).pipe(first()).subscribe(
            data => {
                if(data.authenticated === true){
                  this.router.navigateByUrl("/home");
                } else {
                  setInterval(()=>{
                    this.authenticationService.logout();
                  }, 5000)
                } 

                this.loading = false;
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
            }
        );
  }
   
}

